import firebase from "firebase/app";
//import {FBaseUI} from "firebaseui";
import "firebaseui/dist/firebaseui.css";

import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/es";

import "firebase/firestore";
import { HOSTNAME } from "./services/FetchData";

var FBaseUI = require("firebaseui");

// Initialize Firebase
// TODO: Replace with your project's customized code snippet
const config = {
  apiKey: "AIzaSyDSXFXIVjqvEKuDlHg59b-ER_qe9Yitj6s",
  authDomain: "language-1542910316468.firebaseapp.com",
  databaseURL: "https://language-1542910316468.firebaseio.com",
  projectId: "language-1542910316468",
  storageBucket: "language-1542910316468.appspot.com",
  messagingSenderId: "538973813805",
  appId: "1:538973813805:web:d7c66e5fb87a5637d18ca4",
  measurementId: "G-ZH6TJ1Z3LQ"
};
var firebase_app = firebase.initializeApp(config);

export const fbdb = firebase.firestore();

// FBaseUI.start('#firebaseui-auth-container', {
// signInOptions: [
//     firebase.auth.EmailAuthProvider.PROVIDER_ID,
//     //firebase.auth.FacebookAuthProvider.PROVIDER_ID,
//     //firebase.auth.TwitterAuthProvider.PROVIDER_ID,
// ],
// // Other config options...
// });

// Initialize the FirebaseUI Widget using Firebase.
export const FireBaseUI = new FBaseUI.auth.AuthUI(firebase.auth());

export const FireBaseUIConfig = {
  callbacks: {
    signInSuccessWithAuthResult: function(authResult, redirectUrl) {
      // User successfully signed in.
      // Return type determines whether we continue the redirect automatically
      // or whether we leave that to developer to handle.
      //alert(authResult.user.email + authResult.user.displayName);
      //console.log(authResult);

      localStorage.setItem("user_status", "logged_in");
      localStorage.setItem("auth_token", authResult.user.email);

      window.location = "/home";

      return false;
    },
    uiShown: function() {
      // The widget is rendered.
      // Hide the loader.
      document.getElementById("loader").style.display = "none";
    }
  },
  // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
  signInFlow: "popup",
  signInSuccessUrl: "http://localhost:3000",
  signInOptions: [
    // Leave the lines as is for the providers you want to offer your users.
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    firebase.auth.FacebookAuthProvider.PROVIDER_ID
    //firebase.auth.TwitterAuthProvider.PROVIDER_ID,
    //firebase.auth.GithubAuthProvider.PROVIDER_ID,
    //firebase.auth.EmailAuthProvider.PROVIDER_ID,
    //firebase.auth.PhoneAuthProvider.PROVIDER_ID
  ],
  // Terms of service url.
  tosUrl: "http://localhost:3000/termsofservice",
  // Privacy policy url.
  privacyPolicyUrl: "http://localhost:3000/privacypolicy"
};

firebase
  .auth()
  .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
  .then(function() {
    // Existing and future Auth states are now persisted in the current
    // session only. Closing the window would clear any existing state even
    // if a user forgets to sign out.
    // ...
    // New sign-in will be persisted with session persistence.
    return firebase.auth().signInWithEmailAndPassword("email", "password");
  })
  .catch(function(error) {
    // Handle Errors here.
    var errorCode = error.code;
    var errorMessage = error.message;
  });

// firebase.auth().onAuthStateChanged(function (user) {
//     if (user) {
//         // User is signed in.
//         //alert('signed in')
//     } else {
//         // No user is signed in.
//     }
// });

// firebase.auth().signOut().then(function () {
//     // Sign-out successful.
//     alert('signed out')
// }, function (error) {
//     // An error happened.
// });

// The start method will wait until the DOM is loaded.
//FireBaseUI.start('#firebaseui-auth-container', FireBaseUIConfig);

export function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function isStorageSupported() {
  if (typeof Storage !== "undefined") {
    // Code for localStorage/sessionStorage.
    return true;
  } else {
    // Sorry! No Web Storage support..
    /* return (
          <p>
            This browser doesn't support local storage. Reccomend to use updated
            Google Chrome or Mozilla Firefox.
          </p>
        ) */
    return false;
  }
}

export function clearWord(word) {
  let clearWord = word;
  const regex = /(\n+|\s+|,|\.)/gim;
  //clearWord = clearWord.replace(regex, "");

  return clearWord;
}

export function modifyContent(content) {
  let modified_content = content;

  let m;
  const EOLRegex = /<div><br><\/div>$/gim;
  let mEOL = false;

  while ((m = EOLRegex.exec(modified_content)) !== null) {
    // This is necessary to avoid infinite loops with zero-width matches
    if (m.index === EOLRegex.lastIndex) {
      EOLRegex.lastIndex++;
    }

    // The result can be accessed through the `m`-variable.
    m.forEach((match, groupIndex) => {
      //console.log(`Found match, group ${groupIndex}: ${match}`);
      mEOL = true;
    });
  }
  if (mEOL) return modified_content;
  //return HTML
  else return modified_content;
  //return HTML
}

export function buildEditableHtml(html, innertext, response) {
  const regex = /(\S+)/gim;
  let m;

  let typedString = html;
  //typedString = typedString.replace("\n","<br />")
  //typedString = typedString.replace("<mark>","")
  //typedString = typedString.replace("</mark>","")
  //typedString = typedString.replace(regex, "<mark>$&</mark>")
  //typedString = typedString.replace("hello","&lt;b&gt;bold&lt;/b&gt;")
  //typedString = typedString.replace("hello","<b>world</b>")

  //iterating over words
  let wordMap = stringToArray(innertext);
  //console.log('word array ', wordMap)
  // let HTML = "";
  // for (var i = 0; i < wordMap.length; i++) {
  //   if (i % 5 === 0) {
  //     HTML = HTML + "<mark>" + wordMap[i] + "</mark>";
  //   } else {
  //     HTML = HTML + "<span>" + wordMap[i] + "</span>";
  //   }
  // }
  // console.log(HTML)

  let wrongWords = [];

  response.map(function(value, index, array) {
    if (value === 0) wrongWords.push(wordMap[index]);
  });

  wrongWords.map(function(value, index, array) {
    if (value === 0) {
      //typedString = typedString.replace("<mark>" + match + "</mark>","")
      //typedString = typedString.replace(match, "<mark>" + match + "</mark>")
    }
  });

  while ((m = regex.exec(innertext)) !== null) {
    // This is necessary to avoid infinite loops with zero-width matches
    if (m.index === regex.lastIndex) {
      regex.lastIndex++;
    }

    // The result can be accessed through the `m`-variable.
    m.forEach((match, groupIndex) => {
      //console.log(`Found match, group ${groupIndex}: ${match}`);
      if (wrongWords.includes(match)) {
        //typedString = typedString.replace("<mark>" + match + "</mark>","")
        //typedString = typedString.replace(match, "<mark>" + match + "</mark>")
      }
    });
  }

  console.log(html);
  console.log(countWords(innertext), innertext, response);
  console.log("=>", typedString);
  console.log(" ");

  const EOLRegex = /<div><br><\/div>$/gim;
  let mEOL = false;

  while ((m = EOLRegex.exec(typedString)) !== null) {
    // This is necessary to avoid infinite loops with zero-width matches
    if (m.index === EOLRegex.lastIndex) {
      EOLRegex.lastIndex++;
    }

    // The result can be accessed through the `m`-variable.
    m.forEach((match, groupIndex) => {
      //console.log(`Found match, group ${groupIndex}: ${match}`);
      mEOL = true;
    });
  }
  if (mEOL) return typedString;
  //return HTML
  else return typedString + "<div><br></div>";
  //return HTML
}

export function countWords(text) {
  //text = text.replace(/\n/gim," ")
  if (text == null || text.length < 1) return 0;
  if (text.match(/\S+/gim)) return text.match(/\S+/gim).length;
  else return 0;
}

export function stringToArray(text) {
  //text = text.replace(/\n/gim," ")
  if (text == null || text.length < 1) return [];
  if (text.match(/\S+/gim)) return text.match(/\S+/gim);
  else return [];
}

export function copyElemText(text) {
  // Create a dummy input to copy the string array inside it
  var dummy = document.createElement("input");

  // Add it to the document
  document.body.appendChild(dummy);

  // Set its ID
  dummy.setAttribute("id", "dummy_id");

  // Output the array into it
  document.getElementById("dummy_id").value = text;

  // Select it
  dummy.select();

  // Copy its contents
  document.execCommand("copy");

  // Remove it as its not needed anymore
  document.body.removeChild(dummy);
}

export function mobileOrDesktop() {
  var check = false;
  (function(a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}

export function clog(string) {
  console.log(string);
}

export function wrong_words_array(typedText, probability) {
  let wordMap = stringToArray(typedText);

  let wrongWords = [];

  probability.map(function(value, index, array) {
    if (value === 0 && wordMap[index] !== undefined)
      wrongWords.push(wordMap[index]);
  });

  return wrongWords;
}

export const mui_theme = createMuiTheme({
  typography: {
    useNextVariants: true
  }
});

export function log(logString) {
  console.log(logString);
}

export function lastWord(text) {
  var n = text.split(" ");
  return n[n.length - 1];
}

const char_mapping = [
  "\n",
  " ",
  "-",
  "e",
  "f",
  "l",
  "n",
  "o",
  "r",
  "s",
  "t",
  "w",
  "ঁ",
  "ং",
  "অ",
  "আ",
  "ই",
  "উ",
  "এ",
  "ও",
  "ক",
  "খ",
  "গ",
  "ঘ",
  "চ",
  "ছ",
  "জ",
  "ট",
  "ঠ",
  "ড",
  "ণ",
  "ত",
  "থ",
  "দ",
  "ধ",
  "ন",
  "প",
  "ফ",
  "ব",
  "ম",
  "য",
  "ল",
  "শ",
  "ষ",
  "স",
  "হ",
  "়",
  "া",
  "ি",
  "ী",
  "ু",
  "ূ",
  "ৃ",
  "ে",
  "ৈ",
  "ো",
  "ৌ",
  "্",
  "ৎ",
  "য়",
  "ৰ",
  "ৱ",
  "’"
];

export function chars2Num(text) {
  let textArray = text.split("");
  let numArray = [];
  let char;
  let i = 0;

  while (i < 20) {
    let char_index = char_mapping.indexOf(textArray[i]);
    if (char_index === -1) char_index = 0;
    numArray.push(char_index);
    i++;
  }

  // for (char of textArray) {
  //   numArray.push(char_mapping.indexOf(char));
  // }
  return numArray;
}

//deprecated
export function getWordOnCursor(quillText, cursorPosition) {
  let startIndex = cursorPosition;
  let endIndex = cursorPosition;

  while (true) {
    if (startIndex > 0) {
      //console.log(quillText[startIndex]);
      startIndex--;
      if (
        quillText[startIndex] === " " ||
        quillText[startIndex] === "\n" ||
        quillText[startIndex] === ","
      ) {
        startIndex++;
        break;
      }
    } else {
      break;
    }
  }

  while (true) {
    if (endIndex < quillText.length) {
      //console.log(quillText[endIndex]);
      if (
        quillText[endIndex] === " " ||
        quillText[endIndex] === "\n" ||
        quillText[endIndex] === ","
      )
        break;
      endIndex++;
    } else {
      break;
    }
  }

  const typedWord = quillText.slice(startIndex, endIndex);
  return [typedWord, startIndex, endIndex];

  /* var sel,
    word = "";

  if (window.getSelection && (sel = window.getSelection()).modify) {
    var selectedRange = sel.getRangeAt(0);
    sel.collapseToStart();
    sel.modify("move", "backward", "word");
    sel.modify("extend", "forward", "word");

    word = sel.toString();

    // Restore selection
    sel.removeAllRanges();
    sel.addRange(selectedRange);
  } 
  else if ((sel = document.selection) && sel.type !== "Control") {
    var range = sel.createRange();
    range.collapse(true);
    range.expand("word");
    word = range.text;
  }
  return word; */
}

export function shortenWord(word) {
  if (word.length > 18) {
    //return word;
    return word.slice(0, 18) + "...";
  } else {
    return word;
  }
}

export const assameseBindings = {
  unga: {
    key: "q",
    handler: function(range) {
      this.quill.insertText(range, "ঙ");
    }
  },
  wabba: {
    key: "w",
    handler: function(range) {
      this.quill.insertText(range, "ৱ");
    }
  },
  ekaar: {
    key: "e",
    handler: function(range) {
      this.quill.insertText(range, "ে");
    }
  },
  ra: {
    key: "r",
    handler: function(range) {
      this.quill.insertText(range, "ৰ");
    }
  },
  dointyata: {
    key: "t",
    handler: function(range) {
      this.quill.insertText(range, "ত");
    }
  },
  untistaya: {
    key: "y",
    handler: function(range) {
      this.quill.insertText(range, "য়");
    }
  },
  hosoukaar: {
    key: "u",
    handler: function(range) {
      this.quill.insertText(range, "ু");
    }
  },
  hosoikaar: {
    key: "i",
    handler: function(range) {
      this.quill.insertText(range, "ি");
    }
  },
  okaar: {
    key: "o",
    handler: function(range) {
      this.quill.insertText(range, "ো");
    }
  },
  pa: {
    key: "p",
    handler: function(range) {
      this.quill.insertText(range, "প");
    }
  },
  hasanta: {
    key: 220,
    handler: function(range) {
      this.quill.insertText(range, "্");
    }
  },
  aakaar: {
    key: "a",
    handler: function(range) {
      this.quill.insertText(range, "া");
    }
  },
  dointyaxa: {
    key: "s",
    handler: function(range) {
      this.quill.insertText(range, "স");
    }
  },
  dointyada: {
    key: "d",
    handler: function(range) {
      this.quill.insertText(range, "দ");
    }
  },
  murdhoinyata: {
    key: "f",
    handler: function(range) {
      this.quill.insertText(range, "ট");
    }
  },
  ga: {
    key: "g",
    handler: function(range) {
      this.quill.insertText(range, "গ");
    }
  },
  ha: {
    key: "h",
    handler: function(range) {
      this.quill.insertText(range, "হ");
    }
  },
  borgiyaja: {
    key: "j",
    handler: function(range) {
      this.quill.insertText(range, "জ");
    }
  },
  ka: {
    key: "k",
    handler: function(range) {
      this.quill.insertText(range, "ক");
    }
  },
  la: {
    key: "l",
    handler: function(range) {
      this.quill.insertText(range, "ল");
    }
  },
  urdhakoma: {
    key: 222,
    handler: function(range) {
      this.quill.insertText(range, "’");
    }
  },
  jha: {
    key: "z",
    handler: function(range) {
      this.quill.insertText(range, "ঝ");
    }
  },
  khya: {
    key: "x",
    handler: function(range) {
      this.quill.insertText(range, "ক্ষ");
    }
  },
  prothomso: {
    key: "c",
    handler: function(range) {
      this.quill.insertText(range, "চ");
    }
  },
  wabbo: {
    key: "v",
    handler: function(range) {
      this.quill.insertText(range, "ভ");
    }
  },
  ba: {
    key: "b",
    handler: function(range) {
      this.quill.insertText(range, "ব");
    }
  },
  dointyana: {
    key: "n",
    handler: function(range) {
      this.quill.insertText(range, "ন");
    }
  },
  ma: {
    key: "m",
    handler: function(range) {
      this.quill.insertText(range, "ম");
    }
  },
  comma: {
    key: ",",
    handler: function(range) {
      this.quill.insertText(range, ",");
    }
  },
  daari: {
    key: 190,
    handler: function(range) {
      this.quill.insertText(range, "৷");
    }
  },

  // * with shift key
  nya: {
    key: "q",
    shiftKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ঞ");
    }
  },
  ee: {
    key: "e",
    shiftKey: true,
    handler: function(range) {
      this.quill.insertText(range, "এ");
    }
  },
  rikaar: {
    key: "r",
    shiftKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ৃ");
    }
  },
  dointyatha: {
    key: "t",
    shiftKey: true,
    handler: function(range) {
      this.quill.insertText(range, "থ");
    }
  },
  yakaar: {
    key: "y",
    shiftKey: true,
    handler: function(range) {
      this.quill.insertText(range, "্য");
    }
  },
  hrosou: {
    key: "u",
    shiftKey: true,
    handler: function(range) {
      this.quill.insertText(range, "উ");
    }
  },
  hrosoi: {
    key: "i",
    shiftKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ই");
    }
  },
  oo: {
    key: "o",
    shiftKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ও");
    }
  },
  fa: {
    key: "p",
    shiftKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ফ");
    }
  },
  aa: {
    key: "a",
    shiftKey: true,
    handler: function(range) {
      this.quill.insertText(range, "আ");
    }
  },
  talobyaxa: {
    key: "s",
    shiftKey: true,
    handler: function(range) {
      this.quill.insertText(range, "শ");
    }
  },
  dointydha: {
    key: "d",
    shiftKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ধ");
    }
  },
  murdhoinyatha: {
    key: "f",
    shiftKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ঠ");
    }
  },
  gho: {
    key: "g",
    shiftKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ঘ");
    }
  },
  bisarga: {
    key: "h",
    shiftKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ঃ");
    }
  },
  untistaja: {
    key: "j",
    shiftKey: true,
    handler: function(range) {
      this.quill.insertText(range, "য");
    }
  },
  kha: {
    key: "k",
    shiftKey: true,
    handler: function(range) {
      this.quill.insertText(range, "খ");
    }
  },
  colon: {
    key: 186,
    shiftKey: true,
    handler: function(range) {
      this.quill.insertText(range, ":");
    }
  },
  doubleInvertedComma: {
    key: 222,
    shiftKey: true,
    handler: function(range) {
      this.quill.insertText(range, "“");
    }
  },
  dorero: {
    key: "x",
    shiftKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ঢ়");
    }
  },
  dwitiyasa: {
    key: "c",
    shiftKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ছ");
    }
  },
  bha: {
    key: "b",
    shiftKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ভ");
    }
  },
  murdhoinyana: {
    key: "n",
    shiftKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ণ");
    }
  },
  onusaar: {
    key: "m",
    shiftKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ং");
    }
  },

  // * alt key starts from here
  chandrabindu: {
    key: "1",
    altKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ঁ");
    }
  },
  onusaarAlt: {
    key: "2",
    altKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ং");
    }
  },
  khontoittyo: {
    key: "3",
    altKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ৎ");
    }
  },
  doctor: {
    key: "4",
    altKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ড°");
    }
  },
  daktar: {
    key: "5",
    altKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ডা°");
    }
  },
  proyato: {
    key: "6",
    altKey: true,
    handler: function(range) {
      this.quill.insertText(range, "১");
    }
  },
  om: {
    key: "7",
    altKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ॐ");
    }
  },
  star: {
    key: "8",
    altKey: true,
    handler: function(range) {
      this.quill.insertText(range, "★");
    }
  },
  horon: {
    key: "9",
    altKey: true,
    handler: function(range) {
      this.quill.insertText(range, "÷");
    }
  },
  oikaar: {
    key: "e",
    ctrlKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ৈ");
    }
  },
  rri: {
    key: "r",
    altKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ঋ");
    }
  },
  dirghaukaar: {
    key: "u",
    ctrlKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ূ");
    }
  },
  dirghoikaar: {
    key: "y", //"i",
    ctrlKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ী");
    }
  },
  oukaar: {
    key: "o",
    altKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ৌ");
    }
  },
  unknownkaar: {
    key: "p",
    altKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ৗ");
    }
  },
  a: {
    key: "a",
    altKey: true,
    handler: function(range) {
      this.quill.insertText(range, "অ");
    }
  },
  murdhoinyaxa: {
    key: "s",
    altKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ষ");
    }
  },
  murdhoinyada: {
    key: "d",
    altKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ড");
    }
  },
  jhaAlt: {
    key: "j",
    altKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ঝ");
    }
  },
  dorera: {
    key: "x",
    altKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ড়");
    }
  },
  copyright: {
    key: "c",
    altKey: true,
    handler: function(range) {
      this.quill.insertText(range, "©");
    }
  },
  fullstop: {
    key: "1",
    altKey: true,
    handler: function(range) {
      this.quill.insertText(range, ".");
    }
  },
  // * shift alt starts here
  oi: {
    key: "e",
    altKey: true,
    shiftKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ঐ");
    }
  },
  ref: {
    key: "r",
    altKey: true,
    shiftKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ৰ্");
    }
  },
  dirghou: {
    key: "u",
    altKey: true,
    shiftKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ঊ");
    }
  },
  dirghoi: {
    key: "i",
    altKey: true,
    shiftKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ঈ");
    }
  },
  ou: {
    key: "o",
    altKey: true,
    shiftKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ঔ");
    }
  },
  murdhoinyadha: {
    key: "d",
    altKey: true,
    shiftKey: true,
    handler: function(range) {
      this.quill.insertText(range, "ঢ");
    }
  }
};

export const KEY_MAP = [
  ["q", "ঙ"],
  ["w", "ৱ"],
  ["e", "ে"],
  ["r", "ৰ"],
  ["t", "ত"],
  ["y", "য়"],
  ["u", "ু"],
  ["i", "ি"],
  ["o", "ো"],
  ["p", "প"],
  ["\\", "্"],
  ["a", "া"],
  ["s", "স"],
  ["d", "দ"],
  ["f", "ট"],
  ["g", "গ"],
  ["h", "হ"],
  ["j", "জ"],
  ["k", "ক"],
  ["l", "ল"],
  ["'", "’"],
  ["z", "ঝ"],
  ["x", "ক্ষ"],
  ["c", "চ"],
  ["v", "ভ"],
  ["b", "ব"],
  ["n", "ন"],
  ["m", "ম"],
  [",", ","],
  [".", "৷"],
  ["Shift + q", "ঞ"],
  ["Shift + e", "এ"],
  ["Shift + r", "ৃ"],
  ["Shift + t", "থ"],
  ["Shift + y", "্য"],
  ["Shift + u", "উ"],
  ["Shift + i", "ই"],
  ["Shift + o", "ও"],
  ["Shift + p", "ফ"],
  ["Shift + a", "আ"],
  ["Shift + s", "শ"],
  ["Shift + d", "ধ"],
  ["Shift + f", "ঠ"],
  ["Shift + g", "ঘ"],
  ["Shift + h", "ঃ"],
  ["Shift + j", "য"],
  ["Shift + k", "খ"],
  ["Shift + ;", ":"],
  ["Shift + '", "“"],
  ["Shift + x", "ঢ়"],
  ["Shift + c", "ছ"],
  ["Shift + b", "ভ"],
  ["Shift + n", "ণ"],
  ["Shift + m", "ং"],
  ["Alt + 1", "ঁ"],
  ["Alt + 2", "ং"],
  ["Alt + 3", "ৎ"],
  ["Alt + 4", "ড°"],
  ["Alt + 5", "ডা°"],
  ["Alt + 6", "১"],
  ["Alt + 7", "ॐ"],
  ["Alt + 8", "★"],
  ["Alt + 9", "÷"],
  ["Ctrl + e", "ৈ"],
  ["Alt + r", "ঋ"],
  ["Ctrl + u", "ূ"],
  ["Ctrl + y", "ী"],
  ["Alt + o", "ৌ"],
  ["Alt + p", "ৗ"],
  ["Alt + a", "অ"],
  ["Alt + s", "ষ"],
  ["Alt + d", "ড"],
  ["Alt + j", "ঝ"],
  ["Alt + x", "ড়"],
  ["Alt + c", "©"],
  ["Alt + q", "ং"],
  ["Alt + Shift + e", "ঐ"],
  ["Alt + Shift + r", "ৰ্"],
  ["Alt + Shift + u", "ঊ"],
  ["Alt + Shift + i", "ঈ"],
  ["Alt + Shift + o", "ঔ"],
  ["Alt + Shift + d", "ঢ"]
];

//Quill.js codes below
export const toolbarOptions = [
  [{ size: ["small", false, "large", "huge"] }], // custom dropdown
  [{ font: [] }],

  ["bold", "italic", "underline", "strike", "link"], // toggled buttons
  ["blockquote" /* "code-block" */],

  //[{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  //[{ script: "sub" }, { script: "super" }], // superscript/subscript
  //[{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ direction: "rtl" }], // text direction

  //[{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ align: [] }],

  ["clean"] // remove formatting button
];

export function removeElementsByClass(className) {
  var elements = document.getElementsByClassName(className);
  while (elements.length > 0) {
    elements[0].parentNode.removeChild(elements[0]);
  }
}

export const getWordPHP = `${HOSTNAME}/get_typing_words`;
export const submitPHP = `${HOSTNAME}/submit_typing_words`;

export const viewLocalStorage = () => {
  console.log("local storage");
  for (let i = 0; i < localStorage.length; i++) {
    console.log(
      localStorage.key(i) +
        "=[" +
        localStorage.getItem(localStorage.key(i)) +
        "]"
    );
  }
};

export function getIndexArray(array, index) {
  let values = [];

  array.forEach(function(arrayItem) {
    let x = arrayItem[index];
    values.push(x);
  });

  return values;
}
